import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  name: "user-add",
  data: function data() {
    return {
      phonePrefixList: [],
      form: {
        phonePrefixId: "",
        phone: "",
        password: ""
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getPhoneCodeList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getPhoneCodeList: function getPhoneCodeList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.getPhonePrefixLoading = true;
              _context2.n = 1;
              return _this2.$api.getAllPhoneCodeList();
            case 1:
              res = _context2.v;
              _this2.phonePrefixList = res.data;
              _this2.getPhonePrefixLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!_this3.form.phonePrefixId || !_this3.form.phone || !_this3.form.password)) {
                _context3.n = 1;
                break;
              }
              _this3.$message.error("请填写完整用户信息");
              return _context3.a(2);
            case 1:
              if (!(_this3.form.password.length < 8)) {
                _context3.n = 2;
                break;
              }
              _this3.$message.error("密码不可小于 8 位");
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return _this3.$api.setPassword(_this3.form);
            case 3:
              res = _context3.v;
              _this3.$message.success("操作成功");
              // 操作上报
              _this3.$operationLog.push({
                code: 'resetpassword',
                userId: res.data,
                operationType: "user",
                detailBatchNo: res.data
              });
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};